import { lazy } from 'react';

export const VendorLandingHome = lazy(() => import("./LandingHome/index.page"));
export const VendorLandingfaq = lazy(() => import("./Landingfaq/index.page"));
export const VendorLandingCMS = lazy(() => import("./LandingCMS/index.page"));